import React from 'react';

import Inputs from '../../../Components/Inputs/Inputs';
import {useTranslation} from 'react-i18next';

const ResetPassword = props => {
	const fieldDetail = JSON.parse(props.formData);
	console.log(fieldDetail);
    const {t} = useTranslation();
	return (
		<div className="form-login animated fadeIn">
            <div className="form-group mb-0 position-relative">
                <label htmlFor="password" className="placeholder secondary_color">{t('Password')}</label>
                <div className="view-password-signup" onClick={() => props.passwordViewHandler("reset","password")}>
                    <i className="far fa-eye fourth_light_color"></i>
                </div>
                <Inputs fieldName="password" formData={JSON.stringify(fieldDetail.password)} changed={props.changed}/>                             
            </div>
            <br />
            <div className="form-group"> 
                <button onClick={props.clicked} className="btn col-12 secondary_bg mt-3 mt-sm-0" disabled={ props.forgotButtonDisabled }>Submit</button>
            </div>

                {
                    props.validationSuccess  ? 
                    <div className="alert alert-success" role="alert">{props.validationSuccess}</div> : null
                }
                {
                    props.validationError  ? 
                    <div className="alert alert-danger" role="alert">{props.validationError}</div> : null
                }
            
        </div> 
	);
}

export default ResetPassword;